import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "admin-index-container" }
const _hoisted_2 = { class: "adming-index-inner" }
const _hoisted_3 = { class: "admin-index-header" }
const _hoisted_4 = { class: "admin-index-content" }

import { ref, onMounted, onUnmounted, computed ,getCurrentInstance, ComponentInternalInstance } from 'vue';
import ReviewHeader from "@/components/modules/reviewHeader/index.vue";
import { useRouter } from 'vue-router';
import DefectReviewAdmin from './defect-review-admin/index.vue';
import TokenSetting from './token-setting.vue';
import { getStorage, watchStorage } from '../../utils/storage';



export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const router = useRouter();
const { proxy } = getCurrentInstance() as ComponentInternalInstance
const getOmsTokenFromStorage = () => getStorage<string>('omsToken') || '';
const omsToken = ref(getOmsTokenFromStorage());
let stopWatchOmsToken: (() => void) | null = null;

// 是否访问
const accessible = computed(() => {
    return omsToken.value || '';
})
const activeTabEnum = {
  设置token: 1,
  缺陷管理: 2,
};

const activeTab = ref<number>(activeTabEnum.设置token);
const syncOmsTokenState = (token: string) => {
    omsToken.value = token;
    if (!token && activeTab.value === activeTabEnum.缺陷管理) {
        activeTab.value = activeTabEnum.设置token;
    }
};

const handleActiveTab = (tab: number) => {
    if (tab != activeTabEnum.设置token && !accessible.value) {
        proxy?.vknMessage.error({
            message:"请先设置omsToken！",
            duration: 1500,
        })
        return;
    }
    activeTab.value = tab;
}

const handleSetOmsToken = (token: string) => {
    syncOmsTokenState(token || '');
}

const handleBack = () => {
    router.push('/home');
}

onMounted(() => {
    stopWatchOmsToken = watchStorage<string>('omsToken', (newVal) => {
        syncOmsTokenState(newVal || '');
    });
});

onUnmounted(() => {
    if (stopWatchOmsToken) {
        stopWatchOmsToken();
        stopWatchOmsToken = null;
    }
});

return (_ctx: any,_cache: any) => {
  const _component_vkm_svg = _resolveComponent("vkm-svg")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(ReviewHeader, {
          class: "admin-header",
          useDefaultLeft: false
        }, {
          left: _withCtx(() => [
            _createVNode(_component_vkm_svg, {
              "icon-name": "back",
              class: "icon",
              onClick: handleBack
            }),
            _cache[2] || (_cache[2] = _createElementVNode("p", { class: "title" }, "在线训练管理端", -1))
          ]),
          center: _withCtx(() => [
            _createElementVNode("button", {
              class: _normalizeClass(["nav-btn", { primary: activeTab.value === activeTabEnum.设置token }]),
              onClick: _cache[0] || (_cache[0] = ($event: any) => (handleActiveTab(activeTabEnum.设置token)))
            }, " 设置token ", 2),
            _createElementVNode("button", {
              class: _normalizeClass(['nav-btn', { 'is-disabled': !accessible.value, primary: activeTab.value === activeTabEnum.缺陷管理 }]),
              onClick: _cache[1] || (_cache[1] = ($event: any) => (handleActiveTab(activeTabEnum.缺陷管理)))
            }, " 缺陷管理 ", 2)
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_4, [
        (activeTab.value === activeTabEnum.缺陷管理)
          ? (_openBlock(), _createBlock(DefectReviewAdmin, { key: 0 }))
          : _createCommentVNode("", true),
        (activeTab.value === activeTabEnum.设置token)
          ? (_openBlock(), _createBlock(TokenSetting, {
              key: 1,
              onOnSetOmsToken: handleSetOmsToken
            }))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}
}

})